import AuthProvider from "../components/AuthProvider";
import DashboardLayout from "../components/DashboardLayout";
import { getOrderPageName } from "../helper/GlobalValueHelper";
import Edit from "../views/order/Detail";
import List from "../views/order/List";

const OrderRoute = {
  element: <DashboardLayout />,
  children: [
    {
      path: "/orders",
      element: (
        <AuthProvider page={getOrderPageName()} action={"view"}>
          <List />
        </AuthProvider>
      ),
    },
    {
      path: "/orders/:id",
      element: (
        <AuthProvider page={getOrderPageName()} action={"update"}>
          <Edit />
        </AuthProvider>
      ),
    },
  ],
};

export default OrderRoute;
